import { sanitizeBrandTokens } from '@authe/fe-commons/theme';
export { brandForegroundFor, isHslTriplet, parseHslTriplet } from '@authe/fe-commons/theme';

// src/theme/branding.ts
function sanitizeBrandOverride(input, options) {
  return sanitizeBrandTokens(input, options);
}

export { sanitizeBrandOverride };
//# sourceMappingURL=chunk-P4WSDWOY.js.map
//# sourceMappingURL=chunk-P4WSDWOY.js.map